import { useQueryClient, useMutation } from "@tanstack/react-query";
import { journeyQueryKeys } from "pages/SingleJourney/queries/keys";
import { updateTestCase } from "./services";
import { invalidateJourneyTestCaseQueries } from "../../../pages/SingleJourney/components/TestCasesTab/queries";
import PageService from "services/PageService";

export const useUpdateTestCaseMutation = (journeyId) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ id, name }) =>
            updateTestCase({ id, name }),
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: [journeyQueryKeys.singleJourney, journeyId],
            });
            invalidateJourneyTestCaseQueries(queryClient, journeyId);
        },
    });
};

export const useDeleteTestCaseMutation = () => {
    return useMutation({
        mutationFn: (id) =>
            PageService.deleteTestCases([id]),
    });
};
